import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fb483fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entity" }
const _hoisted_2 = {
  key: 0,
  class: "links"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-title" }, "Links:", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("沪ICP备15054544号-4")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("沪公网安备 31023002000315号")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copyright 2022", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  rel: "license",
  href: "//creativecommons.org/licenses/by-nc/4.0/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Copyright",
    src: "//i.creativecommons.org/l/by-nc/4.0/80x15.png"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "bug report: march511#gmail.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.links.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (l, idx) => {
            return (_openBlock(), _createBlock(_component_el_link, {
              key: idx,
              href: l.URL,
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(l.Title), 1)
              ]),
              _: 2
            }, 1032, ["href"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_el_link, {
        href: "https://beian.miit.gov.cn/",
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(_component_el_link, {
        href: "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31023002000315",
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _createVNode(_component_router_link, { to: { name: 'AdminLogin' } }, {
        default: _withCtx(() => [
          _createVNode(_component_el_link, { class: "to-login" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_12,
      _hoisted_13
    ])
  ]))
}